import React from "react";

/**
 * Allows consumer to hook into the CSS media queries
 * @param query CSS media query
 * @returns {boolean} whether the CSS media query has been matched
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = React.useState<boolean>(false);

  // Runs once
  // Actually runs when the app rerenders
  // But for our intents and purposes there is no onChange handler applied
  // So we consider it to only run 'once'
  React.useLayoutEffect(() => {
    if (typeof window !== "undefined") {
      setMatches(window.matchMedia(query).matches);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return matches;
};
